import { render, staticRenderFns } from "./MMChoiceDesktop.vue?vue&type=template&id=8d794ec4"
import script from "./MMChoiceDesktop.vue?vue&type=script&lang=js"
export * from "./MMChoiceDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports